import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetHousingStocks = () => axios.get(apiPaths.housingStocksBase);

// Accepts array with one ore more housing stocks
const onCreateHousingStock = (housingStock) => {
  const payload = Array.isArray(housingStock) ? housingStock : [housingStock];
  return axios.post(apiPaths.housingStocksBase, payload);
};

const onUpdateHousingStock = (housingStockId, housingStock) =>
  axios.put(`${apiPaths.housingStocksBase}/${housingStockId}`, housingStock);

const onDeleteHousingStock = (housingStockId) => axios.delete(`${apiPaths.housingStocksBase}/${housingStockId}`);

export { onGetHousingStocks, onCreateHousingStock, onUpdateHousingStock, onDeleteHousingStock };
